import Vue from 'vue'
import sjcl from 'sjcl'
import { AccesSecurise } from '@/domain/AccesSecurise'
import { NativeBiometric } from 'capacitor-native-biometric'
import { Capacitor } from '@capacitor/core'

export default Vue.extend({
    methods: {
        generateToken(password: string, date: string) {
            const hashPassword = sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(password))

            const concatPasswordDate = hashPassword + ':' + date
            return sjcl.codec.hex.fromBits(sjcl.hash.sha256.hash(concatPasswordDate))
        },
        promptPasswordCheck(): Promise<boolean> {
            if (!this.$database.accesSecurise || new Date().getTime() - new Date(this.$database.accesSecurise.dateEmission).getTime() > 20000) {
                const prompt = () => {
                    return this.$swal
                        .prompt('Veuillez rentrer votre mot de passe.', true)
                        .then(a => {
                            if (a.isConfirmed && a.value) {
                                return a.value as string
                            }
                        })
                        .then(a => {
                            if (a) {
                                this.$database.accesSecurise = new AccesSecurise()
                                this.$database.accesSecurise.dateEmission = new Date().toISOString()
                                this.$database.accesSecurise.token = this.generateToken(a, this.$database.accesSecurise.dateEmission)

                                return true
                            }

                            return false
                        })
                }
                if (Capacitor.getPlatform() != 'web')
                    return NativeBiometric.isAvailable().then(value => {
                        if (value.isAvailable) {
                            return NativeBiometric.getCredentials({
                                server: 'recette.biobank.id3i.fr'
                            })
                                .then(cred => {
                                    return NativeBiometric.verifyIdentity({}).then(
                                        () => {
                                            this.$database.accesSecurise = new AccesSecurise()
                                            this.$database.accesSecurise.dateEmission = new Date().toISOString()
                                            this.$database.accesSecurise.token = this.generateToken(cred.password, this.$database.accesSecurise.dateEmission)

                                            return true
                                        },
                                        () => prompt()
                                    )
                                })
                                .catch(() => prompt())
                        } else {
                            return prompt()
                        }
                    })
                else return prompt()
            } else {
                return Promise.resolve(true)
            }
        }
    }
})
